import { clearAuthTokens, getAccessToken, setAuthTokens } from "../../core/utils/token";
import ApiClient from "../nesterenko";
import {
  AuthConfirmResource,
  AuthLoginResource,
  AuthLoginResponse,
  AuthRegistrationResource,
  AuthResetPasswordResource,
} from "../generated-api";

export class ApiAuth {
  static async login(payload: AuthLoginResource) {
    const data = await ApiClient.post<AuthLoginResponse>("/auth/login", payload);

    setAuthTokens(data.access_token, data.refresh_token);
  }

  static async registration(payload: AuthRegistrationResource) {
    return ApiClient.post("/auth/register", payload);
  }

  static async confirm(payload: AuthConfirmResource) {
    return ApiClient.post("/auth/confirm", payload);
  }

  static async resetPassword(payload: AuthResetPasswordResource) {
    return ApiClient.post("/auth/reset-password", payload);
  }

  static async logout() {
    const access_token = getAccessToken();

    if (access_token) {
      await ApiClient.post("/auth/logout");
    }

    await clearAuthTokens();
  }
}
